export class PaginatedResponse {
  constructor({ count = 0, results = [] }) {
    this.count = count;
    this.results = results;
  }
}

export default PaginatedResponse;
